import { type NodeSn, brand } from '@ipfabric/utils';
import type { DeviceViewNodeId } from '../deviceViewTypes';

export const getDeviceViewEntityNodeId = (nodeSn: NodeSn): DeviceViewNodeId =>
  brand<DeviceViewNodeId>(`node${nodeSn}`);
